import PropTypes from "prop-types";

import { Table } from "components/Table";
import { tradeColumns } from "./columns";
import { useNavigation } from "utils/navigate";
import { Title } from "style/components/Title.styles";

export const Trades = ({ data = [], isLoading, isPublicStrategy }) => {
  const { navigateToV2StockDetails } = useNavigation();

  const handleRowClick = (selected) => {
    if (!isPublicStrategy) {
      navigateToV2StockDetails(selected.asset);
    }
  };

  return (
    <>
      <Title className="mb-0">Trades</Title>
      <div className="divider mt-3 mb-0"></div>
      <div className="trades-table">
        <Table
          data={data}
          isLoading={isLoading}
          columns={tradeColumns}
          initialPageSize={15}
          onRowClick={handleRowClick}
          showPagination={false}
        />
      </div>
    </>
  );
};

Trades.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.array,
  isPublicStrategy: PropTypes.bool,
};
